export default __webpack_public_path__ + "static/media/Classwin - New icon_Tutorial.33011bba.svg";